// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import global_  from "@/components/Common/Global";
Vue.prototype.GLOBAL = global_;
// elementUI 导入
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// 调用插件
Vue.use(ElementUI);
import VueQuillEditor from 'vue-quill-editor'
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  Vue.use(VueQuillEditor);
import App from './App'
import router from './router'
// 导入自己编写的全局的css和滑动验证的js文件
import '../static/global/global.css'
import '../static/global/gt.js'
import echarts from 'echarts'
Vue.prototype.$echarts = echarts
// 导入axios
import * as api from './restful/api'
Vue.prototype.$http = api;
// 设置公共的url
// Axios.defaults.baseURL =global_.BASE_URL+'api/';
// store的引入
import store from '../src/store'

//vue-cookies的使用
import VueCookies from 'vue-cookies'
// import Axios from "./restful/axios";
Vue.use(VueCookies)

//通用函数
import utils from './utils'
import {format} from './units1'
Vue.prototype.$format=format;
Vue.use(utils)

// 全局的过滤器     以后如果想处理相同的数据，对数据‘添油加醋’可以在这里声明全局的过滤器
Vue.filter('course_brief',function(brief){
	if (brief.length  > 20) {
		brief = brief.slice(0,35)
		console.log(brief)
		return  `${brief}...`
	}else{
		return brief
	}
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否需要登录权限
    if (VueCookies.get("token")) { // 判断当前的token是否存在
      next();
    }
    else {
      next({
        path: '/login',
        query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  }
  else {
    next();
  }
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js